module.exports = __webpack_public_path__ + "media/newstyle/images/stars_5-orange-ef8e8a12a17cbdd0f13e93933197bf42.svg";